module.exports = __webpack_public_path__ + "img/copy.d4dad38d.svg";